import type { Action } from 'svelte/action';

/**
 * Element shifts subtly with mouse position across window.
 * Usage: <div use:parallax={{ strength: 0.03 }}>
 */
export const parallax: Action<HTMLElement, { strength?: number } | undefined> = (node, params) => {
    const strength = params?.strength ?? 0.03;

    function onMove(e: MouseEvent) {
        const x = e.clientX / window.innerWidth - 0.5;
        const y = e.clientY / window.innerHeight - 0.5;
        node.style.transform = `translate(${x * strength * 30}px, ${y * strength * 30}px)`;
    }

    document.addEventListener('mousemove', onMove);

    return {
        destroy() {
            document.removeEventListener('mousemove', onMove);
        }
    };
};
